<div class="content">
  <div class="content-panel">
    <div class="searchBar">
      <label class="form-label" for="searchBar-input" translate>page.admin.organismes.liste.table.filtrer</label>
      <input type="text" id="searchBar-input" (ngModelChange)="searchStringUpdate.next($event)" [(ngModel)]="searchStringInput"
        placeholder="{{'label.filtre'|translate}}">
    </div>
    <br />
    <div id="liste-operateur-organismes">
      <table class="table table-striped" aria-label="Liste des organismes">
        <thead>
          <tr>
            <th (click)="setOrder('raisonSociale')" (keydown.enter)="setOrder('raisonSociale')" class="sortable">{{ 'page.common.organismes.liste.table.header.raisonSociale' | translate }}<fa-icon [icon]="getIcon('raisonSociale')"></fa-icon></th>
            <th (click)="setOrder('type')" (keydown.enter)="setOrder('type')" class="sortable">{{ 'page.common.organismes.liste.table.header.type' | translate }}<fa-icon [icon]="getIcon('type')"></fa-icon></th>
            <th>{{ 'page.common.organismes.liste.table.header.adresse' | translate }}</th>
            <th>{{ 'page.common.organismes.liste.table.header.telephone' | translate }}</th>
            <th (click)="setOrder('mail')" (keydown.enter)="setOrder('mail')" class="sortable">{{ 'page.common.organismes.liste.table.header.mail' | translate }}<fa-icon [icon]="getIcon('mail')"></fa-icon></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let organisme of organismes | filter : '*': searchString | orderBy:order.property:order.reverse:true">
            <td>{{organisme.raisonSociale}}</td>
            <td>{{organisme.type.libelle}}</td>
            <td>
              <ng-container *ngTemplateOutlet="adresseTemplate;context:{organisme:organisme}"></ng-container>
            </td>
            <td>{{formatPhoneNumber(organisme.telephone)}}</td>
            <td>{{organisme.mail}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>


<ng-template #adresseTemplate let-organisme="organisme">
  <div class="multilines-value">{{organisme.adresse}}</div>
  <div>{{organisme.codePostal}} {{organisme.ville}}</div>
  <div *ngIf="organisme.cedex">{{organisme.cedex}}</div>
  <div *ngIf="organisme.pays">{{organisme.pays.libelle}}</div>
</ng-template>

